import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="text-center py-20">
      <h1 className="text-6xl font-bold text-nexyo-muted">404</h1>
      <p className="mt-4 text-nexyo-muted">This view doesn't exist (yet).</p>
      <Link to="/dashboard" className="nx-button-primary mt-6 inline-block">
        Back to Dashboard
      </Link>
    </div>
  );
}
